import { useEffect, useRef } from 'react';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';

const SVG_WIDTH = 2280;
const SVG_HEIGHT = 1440;

// Coordenadas reales extraidas del SVG (x, y, width, height)
const STANDS_COORDS = {
  'A': { x: 1200.03, y: 556.65, w: 150, h: 300 },
  'B': { x: 987.03, y: 635.4, w: 150, h: 150 },
  'C': { x: 777.03, y: 635.4, w: 150, h: 150 },
  'D': { x: 567.03, y: 635.4, w: 150, h: 75 },
  'E': { x: 567.03, y: 710.4, w: 150, h: 75 },
  '1': { x: 317.53, y: 522.9, w: 45, h: 30 },
  '2': { x: 317.53, y: 477.9, w: 45, h: 30 },
  '3': { x: 317.53, y: 432.9, w: 45, h: 30 },
  '4': { x: 357.03, y: 290.4, w: 225, h: 60 },
  '5': { x: 582.03, y: 290.4, w: 90, h: 60 },
  '6': { x: 672.03, y: 290.4, w: 135, h: 60 },
  '7': { x: 807.03, y: 290.4, w: 135, h: 60 },
  '8': { x: 942.03, y: 290.4, w: 180, h: 60 },
  '9': { x: 1122.03, y: 290.4, w: 375, h: 60 },
  '10': { x: 1119.17, y: 1062.95, w: 330, h: 60 },
  '11': { x: 985.03, y: 1062.9, w: 135, h: 60 },
  '12': { x: 850.03, y: 1062.9, w: 135, h: 60 },
  '13': { x: 715.03, y: 1062.95, w: 135, h: 60 },
  '14': { x: 625.03, y: 1062.95, w: 90, h: 30 },
  '15': { x: 535.03, y: 1062.95, w: 90, h: 30 },
  '16': { x: 445.03, y: 1062.95, w: 90, h: 30 },
  '17': { x: 355.03, y: 1063.37, w: 90, h: 60 },
  '18': { x: 317.53, y: 950.4, w: 45, h: 30 },
  '19': { x: 317.53, y: 905.4, w: 45, h: 30 },
  '20': { x: 317.53, y: 860.4, w: 45, h: 30 },
  '21': { x: 416.35, y: 462.9, w: 45, h: 30 },
  '22': { x: 461.35, y: 462.9, w: 45, h: 30 },
  '23': { x: 416.35, y: 492.9, w: 45, h: 30 },
  '24': { x: 461.03, y: 492.9, w: 45, h: 30 },
  '25': { x: 566.69, y: 462.9, w: 45, h: 30 },
  '26': { x: 611.69, y: 462.9, w: 45, h: 30 },
  '27': { x: 566.69, y: 492.9, w: 45, h: 30 },
  '28': { x: 611.69, y: 492.9, w: 45, h: 30 },
  '29': { x: 717.03, y: 462.9, w: 90, h: 60 },
  '30': { x: 867.03, y: 462.9, w: 90, h: 60 },
  '31': { x: 1017.03, y: 462.9, w: 90, h: 60 },
  '32': { x: 1017.03, y: 890.4, w: 90, h: 60 },
  '33': { x: 867.03, y: 890.4, w: 90, h: 30 },
  '34': { x: 867.03, y: 920.4, w: 90, h: 30 },
  '35': { x: 717.03, y: 890.4, w: 90, h: 60 },
  '36': { x: 567.03, y: 890.4, w: 45, h: 30 },
  '37': { x: 612.03, y: 890.4, w: 45, h: 30 },
  '38': { x: 567.03, y: 920.4, w: 45, h: 30 },
  '39': { x: 612.03, y: 920.4, w: 45, h: 30 },
  '40': { x: 417.03, y: 890.4, w: 45, h: 30 },
  '41': { x: 462.03, y: 890.4, w: 45, h: 30 },
  '42': { x: 417.03, y: 920.4, w: 45, h: 30 },
  '43': { x: 462.03, y: 920.4, w: 45, h: 30 },
  '44': { x: 416.03, y: 747.9, w: 45, h: 30 },
  '45': { x: 461.03, y: 747.9, w: 45, h: 30 },
  '46': { x: 416.03, y: 777.9, w: 45, h: 30 },
  '47': { x: 461.03, y: 777.9, w: 45, h: 30 },
  '48': { x: 416.03, y: 605.4, w: 45, h: 30 },
  '49': { x: 461.03, y: 605.4, w: 45, h: 30 },
  '50': { x: 416.03, y: 635.4, w: 45, h: 30 },
  '51': { x: 461.03, y: 635.4, w: 45, h: 30 },
  '52': { x: 1941.67, y: 672.9, w: 45, h: 30 },
  '53': { x: 1941.67, y: 627.9, w: 45, h: 30 },
  '54': { x: 1941.67, y: 582.9, w: 45, h: 30 },
  '55': { x: 1941.67, y: 537.9, w: 45, h: 30 },
  '56': { x: 1941.67, y: 492.9, w: 45, h: 30 },
  '57': { x: 1941.67, y: 447.9, w: 45, h: 30 },
  '58': { x: 1919.17, y: 380.4, w: 90, h: 30 },
};

export default function MapaStands({
  stands,
  tabActivo,
  onStandClick,
  getColorStand,
  standSeleccionado,
  busqueda,
  onMapReady,
  standResaltado,
}) {
  const contenedorRef = useRef(null);
  const mapRef = useRef(null);
  const capasRef = useRef({});

  // Inicializar mapa una sola vez
  useEffect(() => {
    if (mapRef.current || !contenedorRef.current) return;

    const bounds = [[0, 0], [SVG_HEIGHT, SVG_WIDTH]];

    const map = L.map(contenedorRef.current, {
      crs: L.CRS.Simple,
      minZoom: -2,
      maxZoom: 3,
      zoomControl: false,
      attributionControl: false,
      maxBounds: [
        [-SVG_HEIGHT * 0.1, -SVG_WIDTH * 0.1],
        [SVG_HEIGHT * 1.1, SVG_WIDTH * 1.1],
      ],
      maxBoundsViscosity: 1.0,
      bounceAtZoomLimits: false,
    });

    L.imageOverlay('/Plano Expo Alianza 2026 v3.svg', bounds).addTo(map);
    map.fitBounds(bounds, { padding: [20, 20] });
    map.setMinZoom(map.getZoom() - 0.5);

    mapRef.current = map;
    if (onMapReady) onMapReady(map);

    return () => {
      if (mapRef.current) {
        mapRef.current.remove();
        mapRef.current = null;
      }
    };
  }, []);

  // Dibujar/actualizar rectangulos de stands
  useEffect(() => {
    const map = mapRef.current;
    if (!map || !stands.length) return;

    Object.values(capasRef.current).forEach(c => c.remove());
    capasRef.current = {};

    stands.forEach(stand => {
      const tipo = (stand.tipo_stand || '').toUpperCase();
      if (tipo.includes('SERVICIO') || tipo.includes('PASILLO')) return;

      const coords = STANDS_COORDS[stand.numero_stand];
      if (!coords) return;

      const color = standResaltado && stand.id === standResaltado.id
        ? '#7c3aed'
        : getColorStand(stand, tabActivo);
      const esSel = standSeleccionado?.id === stand.id;

      const rectBounds = [
        [SVG_HEIGHT - coords.y - coords.h, coords.x],
        [SVG_HEIGHT - coords.y, coords.x + coords.w],
      ];

      const rect = L.rectangle(rectBounds, {
        color: esSel ? '#270f2b' : '#666',
        weight: esSel ? 3 : 1,
        fillColor: color,
        fillOpacity: 0.75,
      });

      rect.bindTooltip(
        `<b>#${stand.numero_stand}</b><br>${stand.proveedor || 'Sin proveedor'}`,
        { direction: 'top', className: 'stand-tooltip' }
      );

      rect.on('click', () => onStandClick(stand));
      rect.addTo(map);
      capasRef.current[stand.numero_stand] = rect;
    });
  }, [stands, tabActivo, standSeleccionado, getColorStand, onStandClick, standResaltado]);

  // Abrir tooltip del stand resaltado (sin zoom)
  useEffect(() => {
    if (!standResaltado) return;
    const capa = capasRef.current[standResaltado.numero_stand];
    if (capa) capa.openTooltip();
  }, [standResaltado]);

  return (
    <>
      <style>{`
        .stand-tooltip {
          background: #270f2b;
          color: white;
          border: none;
          border-radius: 6px;
          font-size: 12px;
          padding: 4px 8px;
        }
        .stand-tooltip .leaflet-tooltip-tip {
          border-top-color: #270f2b;
        }
        .leaflet-control-zoom a {
          background: #270f2b !important;
          color: #94b803 !important;
          border-color: #94b803 !important;
        }
        .leaflet-container {
          background: #f0f0f0 !important;
        }
      `}</style>
      <div
        ref={contenedorRef}
        style={{
          width: '100%',
          height: '100%',
          minHeight: 0,
          background: '#f0f0f0',
        }}
      />
    </>
  );
}
